import * as Blockly from 'blockly/core';

export function registerStringPreset(workspace: Blockly.WorkspaceSvg): void {
    const varMap = workspace.getVariableMap();
    if (!varMap.getVariable('str', 'String')) {
        varMap.createVariable('str', 'String');
    }
}
